module.exports = __webpack_public_path__ + "img/wx.13576f8f.png";